module.exports = __webpack_public_path__ + "static/media/esrb-rating-rp.9944c958.svg";